import { combineReducers } from 'redux';

import appointmentAccountFormPayment from './requests/appointment-account-form-payment-req';

export default combineReducers({
  appointmentAccountFormPayment,
});



// WEBPACK FOOTER //
// ./src/redux/appointmnents/index.js